export const SET_LANG = 'SET_LANG';
//# sourceMappingURL=actionTypes.js.map